import '../static/FieldLabel.css';
import React__default, { memo, forwardRef } from "react";
import { S as ScreenReaderContent } from "./ScreenReaderContent.CmT4o4X9.mjs";
import { b as Paragraph } from "./Paragraph.DAcb0zW2.mjs";
import clsx from "clsx";
const fieldlabel = `_fieldlabel_b1b5726`;
const _default = `_default_8734028`;
const placeholder = `_placeholder_51432d8`;
const styles = { fieldlabel, "default": _default, placeholder };
const FieldLabel = memo(
  forwardRef(
    ({
      asPlaceholder,
      className,
      label,
      labelId,
      required,
      requiredLabel = "*",
      labelVisible = true,
      ...props
    }, ref) => {
      if (!labelVisible) {
        return /* @__PURE__ */ React__default.createElement(
          ScreenReaderContent,
          {
            "data-testid": "label-screen-reader",
            as: "label",
            id: labelId,
            className,
            ...props
          },
          label
        );
      }
      return /* @__PURE__ */ React__default.createElement(
        Paragraph,
        {
          as: "label",
          "data-field-label": true,
          "data-testid": "ui-label",
          "data-floating-label": asPlaceholder,
          className: clsx(styles.fieldlabel, className, {
            [styles.default]: !asPlaceholder,
            [styles.placeholder]: asPlaceholder
          }),
          ref,
          id: labelId,
          size: "sm",
          ...props
        },
        label,
        required && /* @__PURE__ */ React__default.createElement("span", { "data-testid": "ui-label-required" }, requiredLabel)
      );
    }
  )
);
export {
  FieldLabel as F
};
//# sourceMappingURL=FieldLabel.D6ciKs0A.mjs.map
